/*
 * yourir-next v0.0.10
 * (c) 2021 Iguana2 Pty. Ltd. - https://yourir.info/
 * License: Creative Commons Attribution No Derivatives 3.0 License
 * (https://creativecommons.org/licenses/by-nd/3.0/legalcode)
 */
var client = {
    _options: {
        clientSideRendering: true
    },
    _onload: [],
    _react_component: null,
    _next_component: null,
    _css_href: null // this is set by the loader
};

var loaded_app_id = null;

var root = null;

if (typeof window !== "undefined")
    root = window;
else if (typeof global !== "undefined")
    root = global;

if (root)
    root.yourirClient = client;
else
    console.warn("YourIR: missing window or global object");

function try_load(app_id)
{
    /*globals defaults*/
    var options = defaults();

    if (app_id) {
        options = options || {};
        options.appID = app_id;
    }

    if (options && options.appID) {
        load({
            appID: options.appID,
            version: options.version
        });
    }
}

function load(options)
{
    if (!root)
        return;

    var doc = root.document;

    if (!doc)
        return false;

    if (typeof(options) === "string") {
        options = {
            appID: options
        };
    }

    var app_id = options.appID;

    if (!app_id) {
        console.error("YourIR: must provide App ID to load");
        return false;
    }

    if (!/^[a-f0-9]{16}/.test(app_id)) {
        console.error("YourIR: App ID ("+app_id+") should be 16 hex chars");
        return false;
    }

    if (loaded_app_id) {
        if (app_id === loaded_app_id) {
            if (!options.quiet)
                console.warn("YourIR: multiple calls to load");
            return true;
        }
        else {
            console.error("YourIR: attempt to load a different App ID");
            return false;
        }
    }

    loaded_app_id = app_id;

    if (root.yourir) {
        if (!options.quiet)
            console.warn("YourIR: already loaded");
        for (var i = 0; i < client._onload.length; i++)
            client._onload[i]();
        return true;
    }

    for (var key in options)
        client._options[key] = options[key];

    var script = doc.createElement("script");

    script.type = "text/javascript";
    script.src = "https://yourir.info/"+app_id+".js";
    script.async = true;
    script.crossOrigin = "anonymous";

    if (doc.head) {
        doc.head.appendChild(script);
        return true;
    }

    if (doc.body) {
        doc.body.appendChild(script);
        return true;
    }

    console.error("YourIR: document has no head or body for loader script");
    return false;
}

function bool_fn(name, rv)
{
    return function () {
        if (root && root.yourir)
            return root.yourir[name]();
        else
            return rv;
    };
}

function onload_fn(name)
{
    return function () {
        var self = this;

        // slice may not be available
        var args = [];
        for (var i = 0, n = arguments.length; i < n; i++)
            args.push(arguments[i]);

        if (root && root.yourir) {
            root.yourir[name].apply(self, args);
        }
        else {
            client._onload.push(function () {
                root.yourir[name].apply(self, args);
            });
        }
    };
}

var api = {
    options: function (options) {
        for (var key in options) {
            if (!client._options[key])
                client._options[key] = options[key];
        }
    },

    load: load,

    loaded: bool_fn("loaded", false),
    initialised: bool_fn("initialised", false),
    isReady: bool_fn("isReady", false),

    available: onload_fn("available"),
    setup: onload_fn("setup"),
    ready: onload_fn("ready"),
    mount: onload_fn("mount"),
    willMount: onload_fn("willUnmount"),
    unmount: onload_fn("unmount"),
    render: onload_fn("render"),
    willRender: onload_fn("willRender"),
    processNode: onload_fn("processNode"),
    processNodeChildren: onload_fn("processNodeChildren"),
    reprocessNode: onload_fn("reprocessNode"),
    removeNode: onload_fn("removeNode"),
    set: onload_fn("set")
};

function MyPromise(cb)
{
    this._cb = cb;
    this._then = [];
    this._value = undefined;
}

MyPromise.prototype.resolve = function () {
    this._value = this._cb();

    for (var i = 0; i < this._then.length; i++)
        this._then[i](this._value);
};

MyPromise.prototype.then = function (fn) {
    var value = this._value;

    /*globals setTimeout*/
    if (this._value)
        setTimeout(function () { fn(value); }, 0);
    else
        this._then.push(fn);

    return this;
};

MyPromise.prototype.catch = function (fn) {
    return this;
};

MyPromise.prototype.finally = function (fn) {
    return this;
};

module.exports = MyPromise;

/*globals client, root, MyPromise, api, loaded_app_id, try_load*/

function clean_version(version)
{
    var m = version.match(/([0-9]+[.][0-9]+[.][0-9]+)/);

    if (m && m[1])
        return m[1];
    else
        return version;
}

function create_next_component(React, Head)
{
    var css_href = client._css_href;
    if (!css_href) {
        var version = clean_version(root.yourir.version());
        css_href = "https://yourir.info/lib/"+version+"/yourir.css";
    }

    var klass = function () {};

    Object.assign(klass.prototype, React.Component.prototype);

    klass.prototype.componentDidMount = function () {
        if (this._yourirElement)
            api.mount(this._yourirElement);
    };

    klass.prototype.componentWillUnmount = function () {
        if (this._yourirElement)
            api.unmount(this._yourirElement);
    };

    klass.prototype.shouldComponentUpdate = function () {
        return false;
    };

    klass.prototype.render = function () {
        var self = this, children;

        return React.createElement(this.props.tag || 'div', {
            className: this.props.hide !== false ? 'yourir-hide-template' : undefined,
            ref: function (e) {
                /*jshint -W093*/
                return self._yourirElement = e;
            }
        }, React.createElement(Head,
                null,
                React.createElement("link", {
                    rel: "stylesheet",
                    href: css_href,
                    key: "yourir-css"
                })
            ), this.props.children);
    };

    return klass;
}

var promise;

function NextComponent(React, Head, dynamic)
{
    if (!promise) {
        promise = new MyPromise(function () {
            if (!client._next_component)
                client._next_component = create_next_component(React, Head);

            return client._next_component;
        });

        client._onload.push(function () {
            promise.resolve();
        });
    }

    return dynamic(function () {
        if (!loaded_app_id)
            try_load();

        return promise;
    }, {
        ssr: false
    });
}


/*globals client, api, NextComponent */

var React = require('react');
var Head = require('next/head');
var dynamic = require('next/dynamic');

function defaults()
{
    /*globals process*/
    if (typeof process !== "undefined") {
        try {
            return {
                appID: process.env.NEXT_PUBLIC_YOURIR_APP_ID,
                version: process.env.NEXT_PUBLIC_YOURIR_VERSION
            };
        }
        catch (e) {
        }
    }
}

client._options.addRequiredCSS = false;
client._options.loadCSS = false;

api.YourIR = NextComponent(React, Head["default"], dynamic["default"]);

module.exports = api;
